export default __webpack_public_path__ + "media/color/qash-dbd6ca61.svg";